<mat-dialog-content class="flex flex-col">
  <div>{{'profile.controls.deleteQuestion' | translate}} <strong>{{data.name}}</strong>?</div>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row justify-between">
  <button mat-raised-button color="primary" (click)="cancel()">{{'profile.controls.cancel' | translate}}</button>
  <button data-cy="delete-search-confirm-button" mat-raised-button color="primary" [mat-dialog-close]="data.name">{{'profile.controls.ok' | translate}}</button>
</mat-dialog-actions>
